import { useState, useEffect, useContext, useCallback } from 'react';
import JobApplicationService from '../Services/job.application.service';
import LoaderContext from '../Context/LoaderContext/Index';
import AuthService from '../Services/auth.service';
import { JobApplication } from '../Entities/job-application.entity';

export const useJobApplication = () => {
    const [applications, setApplications] = useState<JobApplication[]>([]);
    const [appliedJobPostIds, setAppliedJobPostIds] = useState<string[]>([]);
    const { setLoading, setLoadingMessage } = useContext(LoaderContext);
    const jobApplicationService = new JobApplicationService();
    const authService = AuthService.getInstance();

    const fetchApplicationIds = useCallback(async () => {
        try {
            const currentUser = authService.getCurrentUser();
            if (!currentUser) {
                setApplications([]);
                return [];
            }

            setLoading(true);
            setLoadingMessage('Fetching applications...');

            const data = await jobApplicationService.findAllJobApplicationByUserId(currentUser._id);
            if (data) {
                setApplications(data);
                setAppliedJobPostIds(data.map(app => app.jobPost._id));
            } else {
                setApplications([]);
                setAppliedJobPostIds([]);
            }
        } catch (err) {
            console.error('Failed to fetch applications:', err);
            setApplications([]);
            return [];
        } finally {
            setLoading(false);
            setLoadingMessage(null);
        }
    }, [jobApplicationService, authService, setLoading, setLoadingMessage]);

    useEffect(() => {
        fetchApplicationIds();
    }, [fetchApplicationIds]);

    const getApplicationStatus = (jobPostId: string) => {
        const application = applications.find(app => app.jobPost._id === jobPostId);
        return application?.status || 'Not Applied';
    }

    return {
        applications,
        appliedJobPostIds,
        refetch: fetchApplicationIds,
        getApplicationStatus
    };
};
